import { useSite } from '../lib/site-context.jsx';
import { telHref } from '../lib/format.js';
import { LeadForm } from '../ui/LeadForm.jsx';
import { EmptyState } from '../ui/ProjectCard.jsx';

export default function Contact({ data }) {
  const { settings, t } = useSite();
  const offices = data.offices || [];
  const company = settings.company_name || 'KeysGrove';
  const project = data.project;
  return (
    <>
      <section className="section page-head">
        <div className="wrap">
          <span className="section-eyebrow">{t('contact_eyebrow', 'Get in touch')}</span>
          <h1>{t('contact_heading_prefix', 'Contact')} {company}</h1>
          <p className="page-lede">
            Email {settings.general_email ? <a href={`mailto:${settings.general_email}`}>{settings.general_email}</a> : 'us'}
            {settings.general_phone && <> or call <a href={telHref(settings.general_phone)}>{settings.general_phone}</a></>}
            {' '}— or reach any of our offices below directly.
          </p>
        </div>
      </section>
      <section className="section section-flush">
        <div className="wrap contact-grid">
          <div>
            {offices.length === 0
              ? <EmptyState>No offices listed yet.</EmptyState>
              : (
                <div className="office-grid" id="office-grid">
                  {offices.map((o) => (
                    <div className={`office-card${o.is_primary ? ' office-card-primary' : ''}`} key={o.id || o.label}>
                      {o.is_primary ? <span className="office-primary-tag">Head Office</span> : null}
                      <span className="office-eyebrow">Office</span>
                      <h2 className="office-label">{o.label}</h2>
                      <address className="office-address">{o.address}</address>
                      <div className="office-contact">
                        {o.phone && <a className="office-phone" href={telHref(o.phone)}>{o.phone}</a>}
                        {o.email && <a className="office-email" href={`mailto:${o.email}`}>{o.email}</a>}
                      </div>
                    </div>
                  ))}
                </div>
              )}
          </div>
          <div className="contact-form">
            <h2>Send us a message</h2>
            <LeadForm id="contact-lead-form" msgId="contact-lead-msg" prefix="cf" source="Website" projectId={project?.id}
              defaultMessage={project ? `I'd like to know more about ${project.name}.` : ''}
              messagePlaceholder="How can we help?" submitLabel="Send message" successText="Thank you — we'll be in touch shortly." />
          </div>
        </div>
      </section>
    </>
  );
}
